import React from 'react';
import PropTypes from "prop-types";

import {Button} from 'reactstrap';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";


export default class TransactionLegalEntity extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
		afterLegalEntitySave: PropTypes.func.isRequired,
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			id: null,
			binary_id: null,
			object: null,
			legalEntityModalOpen: false,
		};

		this.selectRef = React.createRef();
	}

	handleAfterSave = (legalEntity) => {
		let {current} = this.selectRef;

		this.props.afterLegalEntitySave(legalEntity);

		// Ensure the legal entity select dropdown's label reflects the selected object's name after an edit
		if (current) {
			current.setState({valueLabel: legalEntity.name});
		}
	}

	handleToggleLegalEntityModal = () => {
		this.setState({legalEntityModalOpen: !this.state.legalEntityModalOpen});
	}

	handleAddLegalEntityClick = () => {
		this.setState({
			id: null,
			binary_id: null,
			object: null
		});

		this.handleToggleLegalEntityModal();
	}

	handleEditLegalEntityClick = () => {
		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;

		this.setState({
			id: object.legal_entity,
			binary_id: object.legal_entity_binary_id,
			object: object.legal_entities,
		});

		this.handleToggleLegalEntityModal();
	}

	render() {
		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object;
		/**
		 * @type {Customers_Object}
		 */
		let {properties, shouldLoad, onSelectUpdate} = this.props;
		let {legalEntityModalOpen} = this.state;

		return <div>
			<div className={'form-group'}>
				<div className="row">
					<div className="col-4">
						<span className="input-label">Legal Entity</span>
						<UniversalModalOverride
							locations={this.props.locations}
							states={this.props.states}
							history={this.props.history}
							id={this.state.id}
							binary_id={this.state.binary_id}
							name={"Legal Entity"}
							object={Objects.LegalEntity}
							objectProps={{
								object: this.state.object
							}}
							showModal={legalEntityModalOpen}
							handleToggle={this.handleToggleLegalEntityModal}
							afterSave={this.handleAfterSave}
							size={"xl"}
							url={"legal_entities"}
						/>
					</div>
					<div className="col-8 d-flex">
						<Button
							data-id="add-legalEntity"
							onClick={this.handleAddLegalEntityClick}
							className="select-add"
							size="sm"
							outline color="primary"
						>
							<i className={"fa fa-plus"}/>
						</Button>
						{object.legal_entity ?
							<Button
								data-id="edit-legalEntity"
								onClick={this.handleEditLegalEntityClick}
								className="select-add"
								size="sm"
								outline color="green-meadow"
							>
								<i className={"fa fa-pencil"}/>
							</Button>
							: null}
						<div className={'flex-grow-1'}>
							<Framework.Elements.Select
								ref={this.selectRef}
								shouldLoad={shouldLoad}
								property={properties.legal_entity}
								value={object.legal_entity}
								binary_id={object.legal_entity_binary_id}
								error={object.legal_entity_error}
								object={object.legal_entities}
								update={onSelectUpdate}
								nullable={true}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

	}
}

